module.exports = __webpack_public_path__ + "media/images/countryrect/co-6097e95bb1f28870c19869bc619fc7e4.svg";